<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content above * * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced.  * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * End of Placeholder  * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

@if(!maintenanceMode){

<router-outlet *ngIf="translationsLoaded" />
<app-auth-transition></app-auth-transition>

} @else {

<div class="mode">
  <img src="assets/images/Alphabees_Logo_2026_indigo_solid_optimized.svg" alt="Logo" />

  <h1>Maintenance Page</h1>

  <h3>
    Wir führen gerade Warungsarbeiten durch. <br />Besuchen Sie uns später
    wieder.
  </h3>
</div>

}
